import type { FC } from 'react';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import logo from '../res/img/catasto_energetico_icona.png';

interface LogoProps {
  sx?: SxProps<Theme>;
}
const LogoFooter: FC<LogoProps> = (props) => (
  <div>
    <img src={logo} width={"50"} height="50"/>
  </div>
);

export default LogoFooter;
